import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getExperiencesData } from "../../utils/home-util";

export const getExperiencesDatareq = createAsyncThunk(
  "getExperiencesDatareq",
  async (res) => {
    const responce = await getExperiencesData(res);
    return responce.data;
  }
);

const experiencesSlice = createSlice({
  name: "experiences",
  initialState: {
    experiencesPageData: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getExperiencesDatareq.fulfilled, (state, action) => {
      state.loading = false;
      state.experiencesPageData = action.payload;
      state.error = null;
    });
    builder.addCase(getExperiencesDatareq.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getExperiencesDatareq.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {} = experiencesSlice.actions;
export default experiencesSlice.reducer;
